// Generated by CoffeeScript 1.6.3
/**
 * Common module for all sliders on site
*/

itsoftApp.createModule("slidersLibrary", function() {
  var initQueue, libraryLoaded, module, queue, sliders;
  sliders = $("[class*='js-slider']");
  if (!sliders.length) {
    return false;
  }
  module = this;
  queue = [];
  libraryLoaded = false;
  initQueue = function() {
    var func, _results;
    func = null;
    if (!libraryLoaded) {
      return false;
    }
    DEBUG && console.log("[module slidersLibrary] initQueue function fired, queue.length: " + queue.length);
    _results = [];
    while (queue.length) {
      func = queue.shift();
      if (typeof func === "function") {
        _results.push(func());
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };
  if (typeof window.Swiper !== "undefined") {
    libraryLoaded = true;
    initQueue();
  } else {
    itsoftApp.loadStyle("//cdnjs.cloudflare.com/ajax/libs/Swiper/3.3.1/css/swiper.min.css");
    itsoftApp.loadScript("//cdnjs.cloudflare.com/ajax/libs/Swiper/3.3.1/js/swiper.min.js", function() {
      DEBUG && console.log("[module slidersLibrary] library loaded, ready to init queue");
      libraryLoaded = true;
      return initQueue();
    }, function() {
      itsoftApp.loadStyle("/assets/scripts/swiper-3.3.1/css/swiper.min.css");
      return itsoftApp.loadScript("/assets/scripts/swiper-3.3.1/js/swiper.min.js", function() {
        DEBUG && console.log("[module slidersLibrary] library FINALLY loaded, ready to init queue");
        libraryLoaded = true;
        return initQueue();
      });
    });
  }
  return module.addEvent = function(func) {
    if (typeof func !== "function") {
      return;
    }
    if (!libraryLoaded) {
      queue.push(func);
      return DEBUG && console.log("[module slidersLibrary] function added, count of functions to init now: " + queue.length);
    } else {
      return func();
    }
  };
});

/*
//@ sourceMappingURL=slidersLibrary.map
*/
